// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__q8STs","item":"PaymentsMobile_item__M3JWZ","label":"PaymentsMobile_label__aPmqS","amount":"PaymentsMobile_amount__1jptg"};